import { useEffect, useState, forwardRef } from 'react'
import { connect } from 'react-redux'
import { withBounds } from 'Components'
import { setGraphColorPickerProps } from '../../Context/actions'
import { useGraphData } from '../../Context'
import { Row, Col, Button } from 'antd'
import Feather from '@sysunite/react-feather'
import ColorPicker from 'rc-color-picker'
import 'rc-color-picker/assets/index.css'

const GraphColorPicker = forwardRef(({
  target,
  onSave,
  getColor,
  style,
}, ref) => {

  const [color, setColor] = useState(undefined)
  const [graphCtx, dispatch] = useGraphData()

  useEffect(() =>
    setColor(getColor(target))
  , [target])

  return (
    <div
      ref={ref}
      style={{
        boxShadow: 'rgba(0,0,0,0.06) 0px 4px 12px 0px',
        borderRadius: '9px',
        padding: '8px',
        zIndex: 2,
        position: 'fixed',
        width: 100,
        ...style
      }}
    >
      <Row align='middle'>
        <Col>
          <Button
            type="link"
            onClick={() => dispatch(setGraphColorPickerProps(undefined)) }
            style={{ padding: 0, paddingRight: 16 }}
          >
            <Feather type="x" />
          </Button>
        </Col>
        <Col flex={1}>
          <ColorPicker
            color={color}
            onChange={({color}) => setColor(color)}
            enableAlpha={false}
            onClose={() => onSave(target, color)}
          >
            <Button
              style={{ width: '100%' }}
              type="text"
              icon={
                <Feather
                  style={{ color: '#FFF', mixBlendMode: 'difference'}}
                  type="droplet"
                  />
              }
              className="react-custom-trigger" />
          </ColorPicker>
        </Col>
      </Row>
    </div>
  )
})

export default connect(({ graph }) => ({
    groups: graph.graphData.groups,
  })
  , { }
)(withBounds(GraphColorPicker))
